<!--
* @Name：采购合同验收审批
* @Author: 王超
* @Date: 2025-10-28
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="采购合同验收审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">验收确认单</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="acceptanceItemDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">验收标的</span>
        </template>
        <acceptance-item-details :detailsList="headInfo.contractAccepteItemList" />
      </van-collapse-item>
      <van-collapse-item name="acceptanceAttachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">验收附件</span>
        </template>
        <acceptance-attachment-details
          :detailsList="headInfo.cmContractAccepteFileList"
        ></acceptance-attachment-details>
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { selectInfoById } from '@/api/contractAcceptanceApproval'
import Bridge from '@/components/dsbridge'
import { getProvinceAndFinanceManagerInfo, getStruByPurgrp, invalid } from '@/api/process'
export default {
  name: 'ContractAcceptanceApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'acceptance-item-details': () => import('./components/AcceptanceItemDetails.vue'),
    'acceptance-attachment-details': () => import('./components/AcceptanceAttachmentDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions', 'acceptanceItemDetails', 'acceptanceAttachment'],
      // 主单信息
      headInfo: {},
      // 验收标的列表
      contractAccepteItemList: [],
      // 验收附件列表
      cmContractAccepteFileList: [],
      taskDefKey: '',
      headId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    thisPage() {
      return this
    }
  },
  methods: {
    async initData() {
      const headResp = await selectInfoById(this.headId)
      this.headInfo = headResp.data
      this.contractAccepteItemList = this.headInfo.contractAccepteItemList
      this.cmContractAccepteFileList = this.headInfo.cmContractAccepteFileList
    },
    // 返回到审批待办列表
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    onGetProcessInfo(processInfo) {
      this.taskDefKey = processInfo.taskDefKey
    },
  },
  bpmHooks: {
    async setProcessVariables(type) {
      if (type === 'agree') {
        if (this.taskDefKey === 'Activity_15ihy05') {
          // 获取省总
          const contractCode = this.contractAccepteItemList[0].salesContractNo
          if (
            contractCode === 'null' ||
            contractCode == null ||
            contractCode === 'undefined' ||
            contractCode === undefined ||
            contractCode === ''
          ) {
            this.$notify({
              title: '提示',
              message: '获取销售合同号异常',
              type: 'warning'
            })
            this.$stopExecute()
          }
          const response = await getProvinceAndFinanceManagerInfo({
            contractNo: contractCode,
            roleCode: 'provinceManager'
          })
          if (response.success) {
            const provinceManager = response.data
            return {
              opType: type,
              businessKey: this.headId,
              provinceManager
            }
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
        } else if (this.taskDefKey === 'Activity_1niq54d') {
          // 获取区域负责人
          const contractCode = this.contractAccepteItemList[0].salesContractNo
          if (
            contractCode === 'null' ||
            contractCode == null ||
            contractCode === 'undefined' ||
            contractCode === undefined ||
            contractCode === ''
          ) {
            this.$notify({
              title: '提示',
              message: '获取销售合同号异常',
              type: 'warning'
            })
            this.$stopExecute()
          }
          const response = await getProvinceAndFinanceManagerInfo({
            contractNo: contractCode,
            roleCode: 'districtManager'
          })
          if (response.success) {
            const districtManager = response.data
            return {
              opType: type,
              businessKey: this.headId,
              districtManager
            }
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
        } else if (this.taskDefKey === 'Activity_1siuvl5') {
          // 获取采购组负责人
          // 获取品类采购组审批人
          let catgPurgrpId = ''
          const response = await getStruByPurgrp(this.headInfo.purgrpId)
          if (response.success) {
            catgPurgrpId = response.data.purEngineerId
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
          return {
            opType: type,
            businessKey: this.headId,
            catgPurgrpId
          }
        } else {
          return {
            opType: type,
            businessKey: this.headId
          }
        }
      }
    },
    async afterExecute(type) {
      // 流程处理后
      if (type === 'invalid') {
        // 流程被终止进行的方法
        const response = await invalid(this.headInfo.id)
        if (!response || !response.success) {
          this.$notify({
            title: '提示',
            message: response.message,
            type: 'warning'
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
